export const getUserIdFromUrl = () => {
  const url = window.location.pathname;
  const parts = url.split('/').filter(Boolean); // boş string'leri filtrele
  
  // URL'in admin ile bitip bitmediğini kontrol et
  if (parts.length >= 1 && parts[parts.length - 1] !== 'admin') {
    return parts[parts.length - 1]; // son parça admin değilse userId'dir
  }
  
  // URL admin ile bitiyorsa, ondan önceki parçayı al
  if (parts.length >= 2 && parts[parts.length - 1] === 'admin') {
    return parts[parts.length - 2];
  }
  
  return null; // Hiçbir userId bulunamazsa null döndür
};

export const isAdminRoute = () => {
  const url = window.location.pathname;
  return url.endsWith('/admin');
};